type NativeMessageHandler = { postMessage: (message: string) => void };

// The iOS SDK registers a WKScriptMessageHandler named "strada"
type NativeAppWindow = Window & {
  ReactNativeWebView?: NativeMessageHandler;
  webkit?: { messageHandlers?: { strada?: NativeMessageHandler } };
};

export type NativeApp = 'react-native' | 'ios';

const WIDGET_SOURCES: Record<NativeApp, string> = {
  'react-native': 'react-native-sdk',
  ios: 'ios-sdk'
};

export const getNativeApp = (): NativeApp | null => {
  const { ReactNativeWebView, webkit } = window as NativeAppWindow;
  if (ReactNativeWebView) return 'react-native';
  if (webkit?.messageHandlers?.strada) return 'ios';
  return null;
};

export const postToNativeApp = (message: string): void => {
  const { ReactNativeWebView, webkit } = window as NativeAppWindow;
  (ReactNativeWebView ?? webkit?.messageHandlers?.strada)?.postMessage(message);
};

export const getWidgetSource = (nativeApp: NativeApp | null): string =>
  nativeApp ? WIDGET_SOURCES[nativeApp] : 'web-sdk';
